/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
document.addEventListener("click", function(e) {
  if (e.target.classList.contains("quick-add-btn")) {
    const productId = e.target.dataset.productId;
    const variantSelect = document.querySelector(
      `.quick-variant-select[data-product-id="${productId}"]`
    );
    const variantId = variantSelect.value;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
    })
    .then(res => res.json())
    .then(() => {
      // Refresh cart drawer (native symmetry way)
      document.querySelector("cart-drawer").fetchCart();
    });
  }
});
// working realtime code
// document.addEventListener("click", function(e) {
//   if (e.target.classList.contains("cart-upsell-add")) {
//     e.preventDefault();

//     const btn = e.target;
//     const parent = btn.closest(".cart-upsell-item");
//     const variantSelect = parent.querySelector("select[name='id']");
//     const variantId = variantSelect 
//       ? variantSelect.value 
//       : parent.querySelector("input[name='id']").value;

//     if (!variantId) return;

//     // Add loading state
//     btn.disabled = true;
//     const originalText = btn.innerHTML;
//     btn.innerHTML = "Adding...";

//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1
//       })
//     })
//     .then(res => res.json())
//     .then(() => {
//       // ✅ Use Symmetry’s native cart drawer refresh
//       document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
//       document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
//         detail: { opener: btn }
//       }));

//       btn.innerHTML = "Added!";
//       setTimeout(() => {
//         btn.disabled = false;
//         btn.innerHTML = originalText;
//       }, 1000);
//     })
//     .catch(err => {
//       console.error("Upsell add error:", err);
//       btn.disabled = false;
//       btn.innerHTML = originalText;
//     });
//   }
// });
document.addEventListener("DOMContentLoaded", () => {
  let selectedVariants = {};

  // Handle size option clicks
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("size-option-btn")) {
      const btn = e.target;
      const productId = btn.closest(".quick-size-options").dataset.productId;

      // Remove active class from siblings
      btn.closest(".quick-size-options")
        .querySelectorAll(".size-option-btn")
        .forEach((b) => b.classList.remove("active"));

      // Mark this one active
      btn.classList.add("active");

      // Save selection
      selectedVariants[productId] = btn.dataset.variantId;
    }
  });

  // Handle add to cart
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("quick-add-btn")) {
      e.preventDefault();

      const productId = e.target.dataset.productId;
      const variantId = selectedVariants[productId];

      if (!variantId) {
        alert("Please select a size first!");
        return;
      }

      // Loading state
      e.target.disabled = true;
      const originalText = e.target.innerHTML;
      e.target.innerHTML = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then(() => {
          // ✅ Use Symmetry native cart drawer events
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
            detail: { opener: e.target }
          }));

          // Restore button
          setTimeout(() => {
            e.target.disabled = false;
            e.target.innerHTML = originalText;
          }, 700);
        })
        .catch((err) => {
          console.error("Add to cart error:", err);
          e.target.disabled = false;
          e.target.innerHTML = originalText;
        });
    }
  });
});

